<ng-container *ngIf="!newSignup; else signupV2">
<div id="app-consumer-sign-up" class="app-primary-bg"
    [ngStyle]="{'--form-input-text-color': settingsData.form_font_secondary_color || null, 'background-color':this.settingsData.form_bg_color && !router.url.includes('/signup')? this.settingsData.form_bg_color:'','font-family': settingsData.font_family ? settingsData.font_family : '' }">
    <div class="container app-ticket">
        <div class="row">
            <div class="col-md-6">
                <div class="mt-120 landing-page-auth">
                    <form [formGroup]="signUpForm" fxLayoutAlign="center center">
                        <div fxLayout="row wrap" fxFlex="60%" fxFlex.xs="90%" fxFlex.sm="50%"
                            fxLayoutAlign="center center" class="content-box">
                            <div fxFlex="100%" fxFlex.xs="100%" fxLayoutAlign="center center">
                                <div class="box-title"
                                    [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '' ,'font-size': settingsData.form_fs_main_title ? settingsData.form_fs_main_title: '' ,'font-family': settingsData.font_family ? settingsData.font_family : '' }">
                                    Sign Up</div>
                            </div>
                            <div fxLayout="column" fxLayoutGap="5px grid" fxFlex="100%" class="pt-25">
                                <div fxFlex="100%">
                                    <mat-form-field class="w-100" [style.--form-border-color]="settingsData?.form_font_secondary_color" [style.--before-border-color]="settingsData?.form_font_secondary_color">
                                        <mat-label>
                                            <div class="d-inline-block"
                                                [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '','font-family': settingsData.font_family ? settingsData.font_family : '' }">
                                                First Name</div>
                                        </mat-label>
                                        <input matInput name="firstName"
                                            [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '','font-family': settingsData.font_family ? settingsData.font_family : ''}"
                                            formControlName="firstName" required maxlength="35" allowValues
                                            isInputType="alphaNumeric" autocomplete="given-name">
                                        <mat-error *ngIf="signUpForm.get('firstName').hasError('required')">
                                            Please enter first Name
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div fxFlex="100%">
                                    <mat-form-field class="w-100" [style.--form-border-color]="settingsData?.form_font_secondary_color" [style.--before-border-color]="settingsData?.form_font_secondary_color">
                                        <mat-label>
                                            <div class="d-inline-block"
                                                [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '','font-family': settingsData.font_family ? settingsData.font_family : ''}">
                                                Last Name</div>
                                        </mat-label>
                                        <input matInput name="username"
                                            [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '','font-family': settingsData.font_family ? settingsData.font_family : ''}"
                                            formControlName="lastName" required maxlength="35" allowValues
                                            isInputType="alphaNumeric" autocomplete="family-name">
                                        <mat-error *ngIf="signUpForm.get('lastName').hasError('required')">
                                            Please enter last name
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div fxFlex="100%">
                                    <mat-form-field class="w-100" [style.--form-border-color]="settingsData?.form_font_secondary_color" [style.--before-border-color]="settingsData?.form_font_secondary_color">
                                        <mat-label>
                                            <div class="d-inline-block"
                                                [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '','font-family': settingsData.font_family ? settingsData.font_family : ''}">
                                                Email</div>
                                        </mat-label>

                                        <input matInput name="email"
                                            [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '','font-family': settingsData.font_family ? settingsData.font_family : ''}"
                                            formControlName="email" required maxlength="255" autocomplete="email">
                                        <mat-error *ngIf="signUpForm.get('email').hasError('required')">
                                            Please enter email
                                        </mat-error>
                                        <mat-error
                                            *ngIf="signUpForm.get('email').hasError('email') || signUpForm.get('email').hasError('pattern')">
                                            Please enter valid email
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <!-- <div fxFlex="100%" class="phone-number-placeholder">
                                <span class="placeholder-label">Phone Number
                                    <span
                                        [ngClass]="{'placeholder-label-required' : (signUpForm.get('phone_number').hasError('required')) }">*</span>
                                </span>
                                <mat-form-field class="w-100">
                                    <input matInput countryFlagPhone allowValues isInputType="phone"
                                        formControlName="phone_number" required>
                                    <mat-error *ngIf="signUpForm.get('phone_number').hasError('required')">
                                        Please enter phone number
                                    </mat-error>
                                    <mat-error *ngIf="!signUpForm.get('phone_number').hasError('required') && 
                                signUpForm.get('phone_number').hasError('isInvalid')">
                                        Please enter valid phone number
                                    </mat-error>
                                </mat-form-field>
                            </div> -->

                                <!-- <div fxFlex="100%">
                            <mat-form-field class="w-100">
                                <mat-label>Date of birth</mat-label>
                                <input matInput id="date_of_birth" name="date_of_birth" formControlName="date_of_birth"
                                    (click)="openDatePicker()" required readonly>
                                <mat-error *ngIf="signUpForm.get('date_of_birth').hasError('required')">
                                    Please enter date of birth
                                </mat-error>
                            </mat-form-field>
                        </div> -->

                                <!-- <div fxFlex="100%">
                                <mat-form-field class="w-100">
                                    <mat-label>Age</mat-label>
                                    <mat-select name="date_of_birth" formControlName="date_of_birth" required>
                                        <mat-option value="15">
                                            Under 16
                                        </mat-option>
                                        <mat-option value="16">
                                            16+
                                        </mat-option>
                                        <mat-option value="18">
                                            18+
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="signUpForm.get('date_of_birth').hasError('required')">
                                        Please select age
                                    </mat-error>
                                </mat-form-field>
                            </div> -->

                                <div fxFlex="100%">
                                    <mat-form-field class="w-100" [style.--form-border-color]="settingsData?.form_font_secondary_color" [style.--before-border-color]="settingsData?.form_font_secondary_color">
                                        <mat-label>
                                            <div class="d-inline-block"
                                                [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '','font-family': settingsData.font_family ? settingsData.font_family : ''}">
                                                Password</div>
                                        </mat-label>
                                        <input type="password" matInput
                                            [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '','font-family': settingsData.font_family ? settingsData.font_family : ''}"
                                            name="password" formControlName="password" (input)="passwordValid($event)"
                                            autocomplete="new-password" required>
                                        <mat-error *ngIf="signUpForm.get('password').hasError('required')">
                                            Please enter password
                                        </mat-error>
                                        <mat-error *ngIf="!signUpForm.get('password').hasError('required') && 
                                signUpForm.get('password').hasError('mat-require-strong-pwd')">
                                            Password should contain at least 8 characters with a combination of upper
                                            case,
                                            lower case, special character, and numeric
                                        </mat-error>
                                    </mat-form-field>
                                    <div class="p-valid"
                                        *ngIf="!signUpForm.get('password').dirty && !signUpForm.get('password').touched && signUpForm.get('password').hasError('required') && signUpForm.get('password').hasError('mat-require-strong-pwd')"
                                        [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '','font-family': settingsData.font_family ? settingsData.font_family : ''}">
                                        Password should contain at least 8 characters with a combination of upper case,
                                        lower case, special character, and numeric
                                    </div>
                                </div>
                                <!-- <div fxFlex="100%" class="pt-10 mt-2">
                                <app-password-strength [passwordToCheck]="signUpForm.value.password"
                                    (passwordStrength)="passwordValid($event)"></app-password-strength>
                            </div> -->

                                <div fxFlex="100%" class="pt-10 mt-5">
                                    <mat-form-field class="w-100" [style.--form-border-color]="settingsData?.form_font_secondary_color" [style.--before-border-color]="settingsData?.form_font_secondary_color">
                                        <mat-label>
                                            <div class="d-inline-block"
                                                [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '','font-family': settingsData.font_family ? settingsData.font_family : ''}">
                                                Confirm Password </div>
                                        </mat-label>
                                        <input type="password" matInput
                                            [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '','font-family': settingsData.font_family ? settingsData.font_family : ''}"
                                            name="password" formControlName="confirmPassword"
                                            autocomplete="new-password" required>
                                        <mat-error *ngIf="signUpForm.get('confirmPassword').hasError('required')">
                                            Please enter confirm password
                                        </mat-error>
                                        <mat-error *ngIf="!signUpForm.get('confirmPassword').hasError('required') &&
                                signUpForm.get('confirmPassword').hasError('passwordsNotMatching')">
                                            Passwords must match
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div fxFlex="100%">
                                    <mat-form-field class="w-100" [style.--form-border-color]="settingsData?.form_font_secondary_color" [style.--before-border-color]="settingsData?.form_font_secondary_color">
                                        <mat-label>
                                            <div class="d-inline-block"
                                                [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '','font-family': settingsData.font_family ? settingsData.font_family : '' }">
                                                Referral Code</div>
                                        </mat-label>
                                        <input matInput name="referral_code"
                                            [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '','font-family': settingsData.font_family ? settingsData.font_family : ''}"
                                            formControlName="referral_code" maxlength="35" allowValues>
                                    </mat-form-field>
                                </div>

                                <div fxFlex="40%" fxFlex.xs="100%">
                                    <re-captcha (resolved)="resolved($event)" siteKey="{{captchaKey}}"></re-captcha>
                                </div>
                                <div fxFlex="60%" class="mt-10">
                                    <mat-checkbox name="isAgrees"
                                    [style.--checkbox-color]="settingsData?.form_font_primary_color" [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="isAgrees" (change)="openConsumerAcceptTeams(isAgrees)">
                                        <span>
                                            <p class="ml-3 fs-14"
                                                [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '','font-family': settingsData.font_family ? settingsData.font_family   : ''}">
                                                I agree to the <br> <span [ngStyle]="{'color': settingsData?.footer_font_primary_color}">terms and conditions</span></p>
                                        </span>
                                    </mat-checkbox>

                                </div>
                                <!-- <div fxFlex="100%" fxLayoutAlign="center center" class="mt-30 mb-25">
                            <button mat-flat-button class="square-btn" (click)="signUpUser()">
                                Sign Up
                            </button>
                        </div> -->
                                <div fxFlex="100%" fxLayoutAlign="center center" class="mb-25">
                                    <button mat-flat-button class="flat-primary-button primary-bg-button" [ngClass]="{
                                        'dynamic-bg': settingsData.form_bg_secondary_color,
                                        'dynamic-text': settingsData.form_font_primary_color,
                                        'dynamic-font-family': settingsData.font_family
                                    }"
                                    [ngStyle]="{
                                        '--dynamic-bg-color': settingsData.form_bg_secondary_color,
                                        '--dynamic-text-color': settingsData.form_font_primary_color,
                                        '--dynamic-font-family': settingsData.font_family
                                    }"
                                    (click)="newSignUpUser();">
                                    Create My Account
                                </button>
                                </div>
                                <!-- <div fxFlex="100%" fxLayoutAlign="center center">
                            <h3>Forgot Password?</h3>
                        </div> -->

                                <!-- <div fxFlex="100%" fxFlex.xs="100%" fxLayoutAlign="center center" class="mtb-5" style="color: #847B7B;">
                            - OR -
                        </div>
                        <div fxFlex="100%" fxFlex.xs="100%" fxLayoutAlign="center center" class="mtb-5">
                            SIGN IN WITH
                        </div>
                        <div fxFlex="100%" fxFlex.xs="100%" fxLayoutAlign="center center" class="mtb-5 social-icons pointer">
                            <i class="fa fa-facebook-f" (click)="signInFaceBook()"></i>
                        </div> -->

                                <div fxFlex="100%" fxLayoutAlign="center center" class="mb-5 pointer">
                                    <div (click)="OpenSign();"
                                        [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '','font-family': settingsData.font_family ? settingsData.font_family : '' }">
                                        <span class="go-to-account"
                                            [ngStyle]="{ 'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : '','font-family': settingsData.font_family ? settingsData.font_family : '' }">Already
                                            have an
                                            account?&nbsp;</span><span>Sign
                                            In</span></div>
                                </div>

                            </div>

                        </div>


                    </form>
                </div>
            </div>
            <div class="col-md-6 d-none d-sm-block">
                <div class="c-banner" *ngIf="networkLogo">
                    <img [src]="networkLogo" alt="" class="c-banner-logo">
                </div>
            </div>
        </div>
    </div>
</div>
</ng-container>
<ng-template #signupV2>
    <app-consumer-signup-v2 [form]="signUpForm" [settingsData]="settingsData" [captchaKey]="captchaKey"
        [isAgrees]="isAgrees" [channelName]="channelName" (submitted)="newSignUpUser()" (signIn)="OpenSign()"
        (agreeChange)="isAgrees = $event; openConsumerAcceptTeams($event)" (captchaResolved)="resolved($event)"
        (passwordInput)="passwordValid($event)"></app-consumer-signup-v2>
</ng-template>
